/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentValidationResponse {
    getFixupPrototypeFunction() { return AssessmentValidationResponse.fixupPrototype; }

    static newInstance(model: Partial<AssessmentValidationResponse>): AssessmentValidationResponse {
        let obj = Object.assign(new AssessmentValidationResponse(), model);
        AssessmentValidationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentValidationResponse>): AssessmentValidationResponse {
        if (!model) return null;
        return AssessmentValidationResponse.newInstance(<AssessmentValidationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentValidationResponse) {
        if (!obj) return;

        models.AssessmentValidationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentValidationResponse): boolean {
        Object.setPrototypeOf(obj, AssessmentValidationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Sub Category of Assessment
     */
    sub_category: string;

    /**
     * Status of Assessment Validation
     */
    status: string;

    /**
     * Mandatory Requirements
     */
    mandatory_requirements: any;

    /**
     * Optional Requirements
     */
    optional_requirements: any;

    /**
     * Configuration Status
     */
    configuration_status: any;

}
